import {
  SET_USER_DATA,
  CLEAR_USER_DATA,
} from '../../constants'

export default function UserReducer(
  state = {
    gettingDetails: '',
    isLoggedIn: false,
    usedTrial: false,
    loginChecked: false,
    userPersonalisationOptIn: false,
    vipOptIn: false,
  },
  action = {}
) {
  switch (action.type) {
    case SET_USER_DATA: {
      const firstName = action?.payload?.given_name // eslint-disable-line camelcase
      const lastName = action?.payload?.family_name
      const userId = action?.payload?.['cognito:username']
      let targetedAdvertising = action?.payload?.['custom:targetedAdvertising']
      // converting a true/false string into boolean
      targetedAdvertising = (targetedAdvertising === 'true')
      const userPersonalisationOptIn = (action?.payload?.['custom:personalised'] !== 'false') //
      const vipOptIn = (action?.payload?.vipOptIn === 'true')
      const currentlySubscribed = action?.payload?.subData?.currentlySubscribed
      const usedTrial = action?.payload?.subData?.usedTrial
      const subscriptionMethod = action?.payload?.subData?.subscriptionMethod
      const subscriptionType = action?.payload?.subData?.subscriptionType || null
      const gettingDetails = action.payload
      const isLoggedIn = Boolean(firstName)

      return {
        firstName,
        lastName,
        isLoggedIn,
        currentlySubscribed,
        usedTrial,
        userId,
        loginChecked: true,
        targetedAdvertising,
        userPersonalisationOptIn,
        gettingDetails,
        vipOptIn,
        subscriptionMethod,
        subscriptionType,
      }
    }
    case CLEAR_USER_DATA: {
      return {
        isLoggedIn: false,
        usedTrial: false,
        userPersonalisationOptIn: false,
      }
    }
    default:
      return state
  }
}
